import React, { useMemo } from 'react';

import { DateFormat, formatDateWithYear } from '@lyearn/core/utils/date/formatDate';
import { Tooltip, Typography } from '@lyearn/ui';
import TimeAgo from '@/components/TimeAgo';

import { useMessageItemContext } from '../context';
import { TimestampProps } from '../types';

function MessageTimestamp(props: TimestampProps) {
  const { variant, color, className } = props;
  const message = useMessageItemContext();
  const createdAt = message.createdAt;

  const formattedCreatedOn = useMemo(
    () => formatDateWithYear(createdAt, DateFormat.DateTime),
    [createdAt],
  );

  return (
    <>
      <Tooltip
        classes={{
          tooltip: 'max-w-200',
        }}
        placement="top"
        title={
          <Typography color={color} variant={variant}>
            {formattedCreatedOn}
          </Typography>
        }>
        <span>
          <TimeAgo className={className} color={color} time={createdAt} variant={variant} />
        </span>
      </Tooltip>
    </>
  );
}

export default React.memo(MessageTimestamp);
